import { gql } from '@apollo/client';
const GET_WAREHOUSE_RELEASE = gql `
  query GetWarehouseRelease($id: ID!) {
    node(id: $id) {
      ... on WarehouseReleaseNode {
        id
        releaseId
        status
        createdDate
        modifiedDate
        remarks
        receiver
        allComponentVariantsReady
        sumOfModelQuantities
        warehouseReleaseModel {
          id
          fullName
          modelSpecification {
            id
            itemCode
            image
            brand {
              name
            }
            category {
              name
            }
            season {
              name
            }
            fancyName
            folder {
              id
              path {
                id
                name
              }
            }
          }
          ready
        }
      }
    }
  }
`;
export default GET_WAREHOUSE_RELEASE;
